import { DEFAULT_PAGE_TITLES } from '@wix/a11y-axe-loader';
import seoValidations from '@wix/seo-validations';
import { A11Y_RULES_EXPERIMENTS } from '../../../constants';
import { ValidPageTitleFailedReason } from '../../../types';
import { RuleId, RuleLevel } from '../../../types-v2';
import { parseAxeValidPageTitle } from './axe/parse-axe-valid-page-title';
export const validPageTitleRule = {
  axeParser: parseAxeValidPageTitle,
  checker: (_ref, tools) => {
    let {
      title
    } = _ref;
    const formattedTitle = title.toLowerCase().trim();
    const enableTitleTagRule = tools == null ? void 0 : tools.isExperimentEnabled(A11Y_RULES_EXPERIMENTS.ENABLE_TITLE_TAG_RULE);
    const failedReasons = [];
    for (const langCode of Object.keys(DEFAULT_PAGE_TITLES)) {
      const {
        copy,
        copyOf,
        newPage
      } = DEFAULT_PAGE_TITLES[langCode];
      if (formattedTitle.includes(newPage)) {
        failedReasons.push(ValidPageTitleFailedReason.NewPage);
      }
      if (formattedTitle.includes(copyOf)) {
        failedReasons.push(ValidPageTitleFailedReason.CopyOf);
      }
      if (copy && formattedTitle.includes(copy)) {
        failedReasons.push(ValidPageTitleFailedReason.Copy);
      }
    }
    if (formattedTitle === '') {
      failedReasons.push(ValidPageTitleFailedReason.Empty);
    }
    if (enableTitleTagRule && !seoValidations.pageTitleLength(formattedTitle, {
      validateMinLength: false
    })) {
      failedReasons.push(ValidPageTitleFailedReason.Length);
    }
    const status = failedReasons.length === 0 ? 'passed' : 'failed';
    return {
      failedReasons,
      status,
      title
    };
  },
  level: RuleLevel.Page,
  ruleId: RuleId.VALID_STATIC_PAGE_TITLE
};
//# sourceMappingURL=valid-page-title.js.map